module.exports = __webpack_public_path__ + "static/media/snake-JS.5024e97f.PNG";